(() => {
  if (window.SteepMotion) return;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const fine = matchMedia('(hover: hover) and (pointer: fine)');
  const ease = 'cubic-bezier(.2,.8,.2,1)';
  const activeAnimations = new Set(), particles = new Set(), reveals = new Set();
  const accordionStates = new WeakMap();
  const controls = {
    button: '#MainContent .button,#MainContent .button-secondary,#MainContent .button-custom,quick-add-component button,.steep-pdp-v4 .cta,.steep-pdp-v4 .pack-option,.steep-pdp-v4 .purchase-options button,.steep-pdp-v4 .thumb,.steep-pdp-v4 .show-reviews,.stp7 .cta,.stp7 .play,.stp7 .jump-toggle,.stp7 .review-controls button,.steep-home-button,.steep-home-proof__controls button,.steep-footer__form button,.steep-contact button,.steep-wholesale button,.steep-events button,#cart-drawer button,#cart-drawer select,.header__icon--menu,.menu-drawer__close-button',
    card: 'a.steep-pack-card,a.steep-home-merch__card,product-card:has(a[href]),collection-card:has(a[href])',
    nav: '.menu-list__link,.menu-drawer__menu-item',
    link: '.steep-footer a,.steep-contact__copy a,.stp7 .review-controls a,.steep-pdp-v4 [data-rating-summary],.stp7 .rating a'
  };
  const revealSelector = '.steep-pdp-v4 .flavor-nutrition,.steep-pdp-v4 .proof,.steep-pdp-v4 .comparison,.steep-pdp-v4 .ingredients .section-header,.steep-pdp-v4 .ingredient,.steep-pdp-v4 .reviews .section-header,.steep-pdp-v4 .faq,.stp7 .flavor,.stp7 .proof,.stp7 .ingredients .section-header,.stp7 .ingredient,.stp7 .nutrition,.stp7 .reviews .section-header,.stp7 .faq,.steep-home-story,.steep-home-section-heading,.steep-home-merch__card,.steep-home-wholesale__content,.steep-footer__intro';
  function animate(node, frames, options) {
    if (reduced.matches || !node.isConnected || !node.animate) return null;
    const animation = node.animate(frames, options);
    activeAnimations.add(animation);
    animation.finished.catch(() => {}).finally(() => activeAnimations.delete(animation));
    return animation;
  }
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(({target,isIntersecting}) => {
      if (!isIntersecting) return;
      observer.unobserve(target); reveals.delete(target);
      if (target.closest('[data-steep-reveal]') !== target) return;
      animate(target,[{opacity:.6,translate:'0 6px'},{opacity:1,translate:'0 0'}],{duration:220,delay:Math.min(Number(target.dataset.steepStagger || 0)*25,100),easing:ease});
    });
  }, {threshold:0,rootMargin:'0px 0px -20px 0px'}) : null;
  function select(root, selector) {
    return [...(root.matches?.(selector) ? [root] : []),...root.querySelectorAll(selector)];
  }
  function scan(root) {
    if (!root.querySelectorAll) return;
    Object.entries(controls).forEach(([kind,selector]) => select(root,selector).forEach(node => {
      if (!node.dataset.steepMotion) node.dataset.steepMotion=kind;
    }));
    scanDetails(root);
    select(root,'.steep-pdp-v4 .faq details,.stp7 .faq details,.steep-home-editorial .faq details').forEach(details => {
      if (details.dataset.steepAccordion) return;
      const summary=details.querySelector(':scope > summary'); if (!summary) return;
      const body=document.createElement('div'); body.dataset.steepAccordionBody='';
      [...details.childNodes].filter(node => node!==summary).forEach(node=>body.append(node));
      details.append(body); details.dataset.steepAccordion='true'; summary.setAttribute('aria-expanded',String(details.open));
      accordionStates.set(details,{summary,body,desired:details.open,animation:null,bodyAnimation:null});
    });
    select(root,revealSelector).forEach(node => {
      if (node.dataset.steepReveal) return;
      node.dataset.steepReveal='true';
      const group=node.parentElement;
      if (node.matches('.ingredient')) node.dataset.steepStagger=String([...group.children].indexOf(node));
      if (!observer || reduced.matches || node.getBoundingClientRect().top < innerHeight) return;
      reveals.add(node); observer.observe(node);
    });
  }
  let pressed=null, origin=null, lastBurst=-Infinity, queued=new Set(), frame=0;
  const release=()=>{pressed?.classList.remove('steep-is-pressed');pressed=null;origin=null;};
  document.addEventListener('pointerdown',event=>{
    if (event.button!==0) return;
    const target=event.target.closest('[data-steep-motion="button"],[data-steep-motion="card"]');
    if (!target || target.matches(':disabled,[aria-disabled="true"]') || target.closest('[inert]')) return;
    release();pressed=target;origin={x:event.clientX,y:event.clientY};target.classList.add('steep-is-pressed');
  },{passive:true});
  document.addEventListener('pointermove',event=>{if(origin && Math.hypot(event.clientX-origin.x,event.clientY-origin.y)>8)release();},{passive:true});
  document.addEventListener('pointerup',release,{passive:true});
  document.addEventListener('pointercancel',release,{passive:true});
  document.addEventListener('scroll',release,{passive:true,capture:true});
  window.addEventListener('blur',release);
  function finishAccordion(details,state,open) {
    details.open=open;state.desired=open;state.animation=null;
    details.style.removeProperty('height');details.style.removeProperty('overflow');
    state.body.inert=!open;state.summary.setAttribute('aria-expanded',String(open));
  }
  function toggleAccordion(details) {
    const state=accordionStates.get(details); if(!state)return;
    const start=details.getBoundingClientRect().height, desired=!state.desired;
    state.animation?.cancel();state.bodyAnimation?.cancel();state.desired=desired;
    if (!desired && state.body.contains(document.activeElement)) state.summary.focus();
    state.body.inert=!desired;state.summary.setAttribute('aria-expanded',String(desired));
    if (reduced.matches) {finishAccordion(details,state,desired);return;}
    details.open=true;details.style.height='auto';details.style.overflow='hidden';
    const full=details.getBoundingClientRect().height;
    details.open=false;const closed=details.getBoundingClientRect().height;details.open=true;
    const animation=animate(details,[{height:start+'px'},{height:(desired?full:closed)+'px'}],{duration:220,easing:ease});
    state.animation=animation;
    state.bodyAnimation=animate(state.body,[{opacity:desired?.6:1},{opacity:desired?1:0}],{duration:180,easing:ease});
    if (!animation) {finishAccordion(details,state,desired);return;}
    animation.finished.then(()=>{if(state.animation===animation)finishAccordion(details,state,desired);}).catch(()=>{});
  }
  document.addEventListener('click',event=>{
    const summary=event.target.closest('[data-steep-accordion] > summary');
    if (!summary || event.defaultPrevented || event.target.closest('a,button,input,select')) return;
    event.preventDefault();toggleAccordion(summary.parentElement);
  });
  document.addEventListener('toggle',event=>{
    const state=accordionStates.get(event.target);
    if(state && !state.animation){state.desired=event.target.open;state.summary.setAttribute('aria-expanded',String(event.target.open));state.body.inert=!event.target.open;}
  },true);
  function success(source) {
    if (reduced.matches || performance.now()-lastBurst<300 || document.hidden) return;
    const badge=document.querySelector('.cart-bubble__text,.theme-drawer__badge');
    if (badge) animate(badge,[{scale:'1'},{scale:'1.07'},{scale:'1'}],{duration:180,easing:ease});
    const target=document.querySelector('#cart-drawer[open] .theme-drawer__title') || (source?.isConnected?source:null) || badge;
    if (!target) return;
    const rect=target.getBoundingClientRect();if(!rect.width || !rect.height || rect.bottom<0 || rect.top>innerHeight)return;
    lastBurst=performance.now();
    const count=fine.matches?6:4;
    for(let i=0;i<count && particles.size<30;i++) {
      const particle=document.createElement('i');particle.className='steep-motion-particle';particle.setAttribute('aria-hidden','true');
      particle.style.left=Math.min(innerWidth-8,Math.max(8,rect.left+rect.width/2))+'px';
      particle.style.top=Math.min(innerHeight-8,Math.max(8,rect.top+rect.height/2))+'px';
      document.body.append(particle);particles.add(particle);
      const angle=(i/count)*Math.PI*2,distance=18+(i%3)*5;
      const animation=animate(particle,[{opacity:1,translate:'0 0'},{opacity:0,translate:`${Math.cos(angle)*distance}px ${Math.sin(angle)*distance}px`}],{duration:360,easing:ease});
      if(animation)animation.finished.catch(()=>{}).finally(()=>{particle.remove();particles.delete(particle);});
      else {particle.remove();particles.delete(particle);}
    }
  }
  function image(node,src,alt) {
    node.alt=alt;
    if(node.getAttribute('src')===src)return;
    node.dataset.steepImageFade='true';node.src=src;
    if(node.complete && node.naturalWidth){delete node.dataset.steepImageFade;animate(node,[{opacity:.6},{opacity:1}],{duration:180,easing:ease});}
  }
  document.addEventListener('load',event=>{
    if(event.target.dataset?.steepImageFade){delete event.target.dataset.steepImageFade;animate(event.target,[{opacity:.6},{opacity:1}],{duration:180,easing:ease});}
  },true);
  function settle() {
    resetTilt();pendingVariant='';
    release();activeAnimations.forEach(animation=>animation.cancel());activeAnimations.clear();
    document.querySelectorAll('[data-steep-accordion]').forEach(details=>{const state=accordionStates.get(details);if(state?.animation)finishAccordion(details,state,state.desired);});
    particles.forEach(node=>node.remove());particles.clear();
    if(reduced.matches){reveals.forEach(node=>observer?.unobserve(node));reveals.clear();}
  }
  reduced.addEventListener('change',settle);
  window.addEventListener('pagehide',settle);
  window.addEventListener('resize',()=>{
    document.querySelectorAll('[data-steep-accordion]').forEach(details=>{const state=accordionStates.get(details);if(state?.animation){state.animation.cancel();finishAccordion(details,state,state.desired);}});
  },{passive:true});
  const mutation=new MutationObserver(records=>{
    records.forEach(record=>record.addedNodes.forEach(node=>{if(node.nodeType===1 && !node.classList.contains('steep-motion-particle'))queued.add(node);}));
    reveals.forEach(node=>{if(!node.isConnected){observer?.unobserve(node);reveals.delete(node);}});
    if(frame || !queued.size)return;
    frame=requestAnimationFrame(()=>{frame=0;const nodes=[...queued];queued.clear();nodes.filter(node=>node.isConnected && !nodes.some(parent=>parent!==node && parent.contains(node))).forEach(scan);});
  });
  document.addEventListener('steep:cart-add-confirmed',event=>{pendingVariant=String(event.detail?.variantId || '');const source=document.activeElement;requestAnimationFrame(()=>{success(source);highlightConfirmedRow();});});

  let tiltNode=null, tiltFrame=0, tiltPoint=null, pendingVariant='';
  const detailAnimations=new WeakMap();
  const accentObserver='IntersectionObserver' in window ? new IntersectionObserver(entries=>{
    entries.forEach(({target,isIntersecting})=>{if(isIntersecting){target.dataset.steepAccent='shown';accentObserver.unobserve(target);}});
  },{threshold:0,rootMargin:'0px 0px -20px 0px'}) : null;
  function highlightConfirmedRow() {
    if(!pendingVariant)return;
    const row=[...document.querySelectorAll('#cart-drawer [data-steep-variant-id]')].find(node=>node.dataset.steepVariantId===pendingVariant && !node.hidden);
    if(!row)return;
    pendingVariant='';
    animate(row,[{backgroundColor:'#c9a84830'},{backgroundColor:'transparent'}],{duration:220,easing:ease});
  }
  function scanDetails(root) {
    select(root,'.steep-pack-card,.steep-pdp-v4 .pack-option,.plant-composition,.steep-pdp-v4 .review,.stp7 .review,.steep-home-merch__card,.steep-pdp-v4 .nutrition-motion,.steep-pdp-v4 .cheers,.stp7 .cheers,.steep-pdp-v4 .gallery-pack,.steep-pdp-v4 .thumb,.steep-home-story__media,[class*="ai-image-hover-wrapper-"],.stp7 .stage .can').forEach(node=>node.dataset.steepTilt='true');
    select(root,'.steep-pdp-v4 .section-header .eyebrow,.stp7 .section-header .eyebrow,.steep-home-editorial .steep-home-eyebrow').forEach(node=>{
      if(node.dataset.steepAccent)return;
      node.dataset.steepAccent='ready';
      if(reduced.matches || !accentObserver || node.getBoundingClientRect().top<innerHeight)node.dataset.steepAccent='shown';
      else accentObserver.observe(node);
    });
    select(root,'[data-steep-review-slide]').forEach(updateReview);
    highlightConfirmedRow();
  }
  function updateReview(slide) {
    const button=slide.querySelector('[data-steep-review-expand]'),quote=slide.querySelector('blockquote');
    if(!button || !quote)return;
    const compact=false;
    slide.toggleAttribute('data-steep-review-collapsible',compact);button.hidden=!compact;
  }
  function resetTilt() {
    if(tiltFrame)cancelAnimationFrame(tiltFrame);tiltFrame=0;tiltPoint=null;
    if(tiltNode){tiltNode.style.removeProperty('--steep-tilt-x');tiltNode.style.removeProperty('--steep-tilt-y');}tiltNode=null;
  }
  document.addEventListener('pointermove',event=>{
    if(reduced.matches || !fine.matches || event.pointerType==='touch')return;
    const node=event.target.closest('[data-steep-tilt]');
    if(!node || node.matches(':disabled,[aria-disabled="true"]') || node.closest('[inert]')){resetTilt();return;}
    if(tiltNode!==node){resetTilt();tiltNode=node;}
    tiltPoint={x:event.clientX,y:event.clientY};
    if(tiltFrame)return;
    tiltFrame=requestAnimationFrame(()=>{
      tiltFrame=0;if(!tiltNode?.isConnected || !tiltPoint)return;
      const rect=tiltNode.getBoundingClientRect();if(!rect.width || !rect.height)return;
      const clamp=value=>Math.max(-1.8,Math.min(1.8,value));
      tiltNode.style.setProperty('--steep-tilt-x',clamp((.5-(tiltPoint.y-rect.top)/rect.height)*3.6)+'deg');
      tiltNode.style.setProperty('--steep-tilt-y',clamp(((tiltPoint.x-rect.left)/rect.width-.5)*3.6)+'deg');
    });
  },{passive:true});
  document.addEventListener('pointerout',event=>{if(tiltNode && !tiltNode.contains(event.relatedTarget))resetTilt();},{passive:true});
  fine.addEventListener('change',resetTilt);
  window.addEventListener('blur',resetTilt);
  document.addEventListener('scroll',resetTilt,{capture:true,passive:true});
  document.addEventListener('click',event=>{
    const button=event.target.closest('[data-steep-review-expand]');
    if(button){
      const slide=button.closest('[data-steep-review-slide]');
      const expanded=slide.toggleAttribute('data-steep-review-expanded');
      button.setAttribute('aria-expanded',String(expanded));button.textContent=expanded?button.dataset.less:button.dataset.more;
      slide.closest('[data-steep-review-carousel]')?.dispatchEvent(new Event('steep:review-expansion'));return;
    }
    const pack=event.target.closest('.steep-pdp-v4 .pack-option');
    if(pack && !pack.disabled){
      const art=pack.querySelector('img');if(!art)return;
      detailAnimations.get(art)?.cancel();
      const animation=animate(art,[{scale:'.98'},{scale:'1.025'},{scale:'1'}],{duration:180,easing:ease});
      if(animation)detailAnimations.set(art,animation);
    }
  });
  document.addEventListener('toggle',event=>{
    if(!event.target.matches?.('header-drawer > details'))return;
    event.target.querySelectorAll('.steep-menu-packs .steep-pack-card').forEach((node,index)=>{
      detailAnimations.get(node)?.cancel();
      if(!event.target.open || reduced.matches)return;
      const animation=animate(node,[{opacity:.6,translate:'0 6px'},{opacity:1,translate:'0 0'}],{duration:220,delay:Math.min(index*25,100),easing:ease});
      if(animation)detailAnimations.set(node,animation);
    });
  },true);
  window.addEventListener('resize',()=>{resetTilt();document.querySelectorAll('[data-steep-review-slide]').forEach(updateReview);},{passive:true});
  reduced.addEventListener('change',()=>{if(reduced.matches)document.querySelectorAll('[data-steep-accent]').forEach(node=>{accentObserver?.unobserve(node);node.dataset.steepAccent='shown';});});

  const panel=node=>animate(node,[{opacity:.6,translate:'0 4px'},{opacity:1,translate:'0 0'}],{duration:220,easing:ease});
  window.SteepMotion={success,image,panel};
  const floating=document.querySelector('[data-steep-home-floating]');
  if(floating){
    let animation,showing=false,frame=0;
    const update=()=>{
      frame=0;const hero=document.querySelector('#MainContent [id*="__hero_"]');
      const show=!!hero && hero.getBoundingClientRect().bottom<=0 && !document.querySelector('#cart-drawer dialog[open],header-drawer > details[open]');
      if(show===showing)return;showing=show;animation?.cancel();floating.inert=!show;
      if(show)floating.hidden=false;
      if(reduced.matches){floating.hidden=!show;return;}
      animation=floating.animate(show?[{opacity:0,translate:'0 18px'},{opacity:1,translate:'0 0'}]:[{opacity:1,translate:'0 0'},{opacity:0,translate:'0 18px'}],{duration:show?220:140,easing:ease});
      animation.onfinish=()=>{floating.hidden=!showing;};
    };
    const schedule=()=>{if(!frame)frame=requestAnimationFrame(update);};
    window.addEventListener('scroll',schedule,{passive:true});window.addEventListener('resize',schedule,{passive:true});
    document.addEventListener('toggle',schedule,true);
    document.querySelectorAll('#cart-drawer,header-drawer').forEach(n=>new MutationObserver(schedule).observe(n,{attributes:true,subtree:true,attributeFilter:['open','class']}));
    reduced.addEventListener('change',()=>{animation?.cancel();floating.hidden=!showing;});update();
  }
  scan(document);mutation.observe(document.body,{childList:true,subtree:true});
  document.addEventListener('shopify:section:load',event=>scan(event.target));
})();




/* Touch feedback shares hover visuals without intercepting clicks or scrolling. */
(() => {
  if (window.SteepTouchFeedback) return;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const targets = [
    'a[href]', 'button', 'summary', 'select', 'input[type="radio"]', 'input[type="checkbox"]',
    'label:has(input)', '[role="button"]', '[role="radio"]', '[data-steep-motion]', '[data-steep-tilt]',
    '[id*="__hero_bFkDDJ"] .hero h1 > span', '.steep-pdp-category > span',
    '.flavor-copy h2', '.ingredient-art', '.steep-hover-nutrition', '.proof .video',
    '.steep-home-proof__carousel', 'product-card', 'collection-card', '.review',
    '.steep-trial__taste-photo', '.steep-trial__video-side-photo', '.steep-trial__mission figure',
    '.steep-trial__lifestyle-grid figure', '.steep-matrix__brand', '.steep-home-editorial details',
    '[id*="__section_kNPmyK"] details', 'slideshow-component', 'marquee-component'
  ].join(',');
  const active = new Set();
  let gesture = null, timer = 0;
  const blocked = node => !!node.closest(':disabled,[aria-disabled="true"],[inert]');
  function clear() {
    clearTimeout(timer); timer = 0;
    active.forEach(node => {
      node.classList.remove('steep-touch-active');
      node.dispatchEvent(new CustomEvent('steep:touch-effect', {detail:{active:false}}));
    });
    active.clear(); gesture = null;
  }
  function begin(event) {
    if (!['touch','pen'].includes(event.pointerType) || event.button !== 0 || !event.isPrimary) return;
    clear();
    if (!(event.target instanceof Element) || blocked(event.target)) return;
    let node = event.target;
    while (node && node !== document.body) {
      if (node.matches(targets) && !blocked(node)) active.add(node);
      node = node.parentElement;
    }
    if (!active.size) return;
    gesture = {id:event.pointerId, x:event.clientX, y:event.clientY,
      action:!!event.target.closest('a[href],button,summary,select,input,label,[role="button"],[role="radio"]')};
    active.forEach(node => {
      node.classList.add('steep-touch-active');
      node.dispatchEvent(new CustomEvent('steep:touch-effect', {detail:{active:true}}));
    });
    // Bound a long hold; no pointer capture or preventDefault, so scrolling stays native.
    timer = setTimeout(clear, 8000);
  }
  window.SteepTouchFeedback = {clear};
  document.addEventListener('pointerdown', begin, {passive:true});
  document.addEventListener('pointermove', event => {
    if (gesture && event.pointerId === gesture.id && Math.hypot(event.clientX-gesture.x,event.clientY-gesture.y)>8) clear();
  }, {passive:true});
  document.addEventListener('pointerup', event => {
    if (!gesture || event.pointerId !== gesture.id) return;
    clearTimeout(timer);
    const nutrition = [...active].some(node => node.matches('.steep-hover-nutrition'));
    timer = setTimeout(clear, reduced.matches ? 180 : gesture.action ? 420 : nutrition ? 1400 : 2400);
    gesture = null;
  }, {passive:true});
  document.addEventListener('pointercancel', clear, {passive:true});
  document.addEventListener('scroll', clear, {passive:true,capture:true});
  window.addEventListener('blur', clear);
  window.addEventListener('pagehide', clear);
  window.addEventListener('pageshow', clear);
  document.addEventListener('visibilitychange', () => {if (document.hidden) clear();});
  reduced.addEventListener('change', clear);
  // Clear feedback as soon as a real request disables its control.
  new MutationObserver(() => {
    if ([...active].some(node => !node.isConnected || blocked(node))) clear();
  }).observe(document.body, {subtree:true,attributes:true,attributeFilter:['disabled','aria-disabled','inert'],childList:true});
})();
